module.exports = "/fonts/vendor/material-icons/iconmaterial-icons.woff2?0c35d18bf06992036b691da73d635fc4";